window.Sanitas = window.Sanitas || {}
window.Sanitas.language = 'de'
